<section class="h-screen flex items-center justify-center">
  <div class="flex w-full h-full">
    <!-- Left: Form Section -->
    <div class="w-full lg:w-1/2 flex flex-col items-center justify-between bg-white p-6">
      <!-- Logo -->
      <div class="w-full max-w-lg flex justify-start">
        <img [src]="logoUrl" alt="Logo" class="h-20 w-52"/>
      </div>

      <!-- Form Container -->
      <div>
        <h2 class="text-2xl font-bold">Register Now</h2>
        <p class="text-sm text-gray-600">Create a new account on ProTeamMate</p>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label class="block text-sm font-medium mb-1">First Name <span class="text-red-500">*</span></label>
              <input pInputText formControlName="firstName" class="w-full"/>
              <p *ngIf="isInvalid('firstName')" class="text-red-500 text-xs mt-1">First name is required.</p>
            </div>

            <div>
              <label class="block text-sm font-medium mb-1">Last Name</label>
              <input pInputText formControlName="lastName" class="w-full"/>
            </div>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium mb-1">Company Name <span class="text-red-500">*</span></label>
            <input pInputText formControlName="companyName" class="w-full"/>
            <p *ngIf="isInvalid('companyName')" class="text-red-500 text-xs mt-1">Company name is required.</p>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium mb-1">Work Email <span class="text-red-500">*</span></label>
            <input pInputText formControlName="email" class="w-full" placeholder="username@mailid.com"/>
            <p *ngIf="isInvalid('email')" class="text-red-500 text-xs mt-1">Valid email is required.</p>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium mb-1">Contact No <span class="text-red-500">*</span></label>
            <app-phone-number
              [formControl]="getFormControl('phone')"
              [required]="true"
              [selectedCountryISO]="'in'"
            ></app-phone-number>
          </div>
          <button pButton type="submit" label="Submit" class="w-full bg-blue-600 hover:bg-blue-700"></button>
        </form>

        <div>
          <p class="text-center text-sm mt-6">
            Already have an account?
            <a routerLink="/login" class="text-blue-600 no-underline">Login</a>
          </p>
        </div>

      </div>
      <!-- Footer Placeholder -->
      <div>
        <app-footer></app-footer>
      </div>
    </div>

    <!-- Right: Image Section -->
    <div
      class="hidden lg:flex w-1/2 items-center justify-center relative"
      style="background: linear-gradient(49deg, #1177BD -10.76%, #24419B 39.14%, #24419B 53.75%, #24419B 78.54%, #1177BD 110.95%), #FFF;"
    >
      <!-- Image or Branding -->
      <div class="flex items-center justify-center">
        <img src="assets/loginImages/ClientLoginBackground.png" alt="Background Image" class="max-w-[80%] h-auto"/>
      </div>
    </div>

  </div>
</section>
